import { ChangeEventHandler, MouseEventHandler, useEffect, useState } from "react";
import useCommentsForPicker, { CommentForPicker } from "src/swr/useCommentsForPicker/useCommentsForPicker";
import { CollectorCommentProps } from "../../CollectorComment/CollectorComment";


export const useBigProductCardPickerComment = (ean: string): CollectorCommentProps => {
  const { commentsMap, saveComment, deleteComment } = useCommentsForPicker();

  const defaultComment: CommentForPicker = {
    comment: '',
    persisted: false,
    ean,
  };

  const comment = commentsMap[ean] || defaultComment;

  const {
    persisted,
    comment: initialComment,
  } = comment;

  const [commentValue, setCommentValue] = useState(initialComment);

  const handleBlurCollectorComment = () => {
    saveComment({
      ean,
      persisted,
      comment: commentValue,
    });
  };

  const handleClickCheckbox = () => {
    saveComment({
      ean,
      comment: commentValue,
      persisted: !persisted,
    });
  };

  const handleCommentCrossClick: MouseEventHandler<HTMLButtonElement> = () => {
    setCommentValue('');
    deleteComment(ean);
  };

  const handleChangeCollectorComment: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    setCommentValue(e.target.value);
  };

  useEffect(() => {
    //update the comment field if the comments were loaded later or product has changed
    if (initialComment !== commentValue) {
      setCommentValue(initialComment);
    }
    //should only depend on changing the initial comment, otherwise there will be unexpected calls
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialComment]);

  return {
    onBlur: handleBlurCollectorComment,
    onChange: handleChangeCollectorComment,
    onCrossClick: handleCommentCrossClick,
    value: commentValue,
    crossIsHidden: !commentValue,
    checkboxProps: {
      onCheckboxClick: handleClickCheckbox,
      checkboxIsChecked: persisted,
    },
  };
};
